import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[color:var(--livinora-ink)] text-[color:var(--livinora-paper)] mt-24 atmosphere-dark noise"
      data-testid="footer"
    >
      <div className="container-livinora py-20 md:py-32">
        {/* Brand block + closing CTA */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-end pb-16 md:pb-20 border-b border-[color:var(--livinora-stone-deep)]/30">
          <div className="md:col-span-7">
            <span className="section-label section-label--inverse">
              <span className="section-label-num">∞</span>
              <span className="section-label-rule" aria-hidden="true" />
              <span className="section-label-text">Livinora</span>
            </span>
            <h3 className="display-xl text-4xl md:text-5xl lg:text-6xl mt-8 leading-[1.0] text-balance">
              Ihre Ferienimmobilie,
              <br />
              schlüsselfertig eingerichtet.
            </h3>
            <p className="mt-8 text-[color:var(--livinora-stone)] max-w-md leading-relaxed text-[15px]">
              Kuratierte Einrichtungskonzepte für Ferienhäuser, Ferienwohnungen und Apartments —
              klar, planbar, durchdacht.
            </p>
          </div>
          <div className="md:col-span-5 flex flex-col gap-5 md:items-end">
            <Link
              to="/konfigurator"
              className="btn-livinora bg-[color:var(--livinora-paper)] text-[color:var(--livinora-ink)] hover:bg-white"
              data-testid="footer-cta-configurator"
            >
              Projekt konfigurieren <span>→</span>
            </Link>
            <Link
              to="/kontakt"
              className="btn-livinora border border-[color:var(--livinora-stone)]/60 text-[color:var(--livinora-paper)] hover:bg-[color:var(--livinora-paper)] hover:text-[color:var(--livinora-ink)]"
              data-testid="footer-cta-inquiry"
            >
              Beratung anfragen
            </Link>
          </div>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-12 pt-16">
          <div className="md:col-span-3">
            <span className="micro-label" style={{ color: "var(--livinora-stone)" }}>
              Konzepte
            </span>
            <ul className="mt-6 space-y-3.5 text-[14px] text-[color:var(--livinora-stone)]">
              <li><Link to="/konzepte" className="hover:text-[color:var(--livinora-paper)] transition-colors">Objekttypen</Link></li>
              <li><Link to="/stilserien" className="hover:text-[color:var(--livinora-paper)] transition-colors">Stilserien</Link></li>
              <li><Link to="/refit" className="hover:text-[color:var(--livinora-paper)] transition-colors">Refit</Link></li>
              <li><Link to="/individualisierung" className="hover:text-[color:var(--livinora-paper)] transition-colors">Individualisierung</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <span className="micro-label" style={{ color: "var(--livinora-stone)" }}>
              Planen
            </span>
            <ul className="mt-6 space-y-3.5 text-[14px] text-[color:var(--livinora-stone)]">
              <li><Link to="/konfigurator" className="hover:text-[color:var(--livinora-paper)] transition-colors">Konfigurator</Link></li>
              <li><Link to="/shop" className="hover:text-[color:var(--livinora-paper)] transition-colors">Raumsets</Link></li>
              <li><Link to="/gewerblich" className="hover:text-[color:var(--livinora-paper)] transition-colors">Gewerblich</Link></li>
              <li><Link to="/broschuere" className="hover:text-[color:var(--livinora-paper)] transition-colors">Broschüre</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <span className="micro-label" style={{ color: "var(--livinora-stone)" }}>
              Studio
            </span>
            <ul className="mt-6 space-y-3.5 text-[14px] text-[color:var(--livinora-stone)]">
              <li>
                <Link to="/ueber-uns" className="hover:text-[color:var(--livinora-paper)] transition-colors" data-testid="footer-ueber-uns">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[color:var(--livinora-paper)] transition-colors" data-testid="footer-kontakt">
                  Kontakt
                </Link>
              </li>
            </ul>
            <address className="mt-6 not-italic text-[14px] text-[color:var(--livinora-stone)] leading-[1.85] opacity-80">
              Livinora Interior Concepts
              <br />
              Ein Projekt von Schildmeyer & WHP
            </address>
          </div>
          <div className="md:col-span-3">
            <span className="micro-label" style={{ color: "var(--livinora-stone)" }}>
              Kontakt
            </span>
            <p className="mt-6 text-[14px] text-[color:var(--livinora-stone)] leading-[1.7]">
              Schreiben Sie uns über unser{" "}
              <Link to="/kontakt" className="text-[color:var(--livinora-paper)] underline-offset-4 hover:underline" data-testid="footer-kontakt-link">
                Kontaktformular
              </Link>.
              <br />
              Pflichtangaben im{" "}
              <Link to="/impressum" className="text-[color:var(--livinora-paper)] underline-offset-4 hover:underline">
                Impressum
              </Link>.
            </p>
          </div>
        </div>

        {/* Closing rule */}
        <div className="mt-20 pt-8 border-t border-[color:var(--livinora-stone-deep)]/30 flex flex-col md:flex-row gap-4 md:gap-10 items-start md:items-center text-[10.5px] tracking-[0.22em] uppercase text-[color:var(--livinora-stone)]/80">
          <span>© {year} Livinora</span>
          <Link to="/impressum" className="hover:text-[color:var(--livinora-paper)] transition-colors" data-testid="footer-impressum">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-[color:var(--livinora-paper)] transition-colors" data-testid="footer-datenschutz">
            Datenschutz
          </Link>
          <span className="md:ml-auto opacity-60 italic" style={{ fontFamily: "Cormorant Garamond, serif", letterSpacing: "0.04em", textTransform: "none", fontSize: "13px" }}>
            Made with Architecture. Built for Hospitality.
          </span>
        </div>
      </div>
    </footer>
  );
}
